module.exports = __webpack_public_path__ + "static/media/birthdaysIcons.de040e1a.svg";